<template>
    <div class="error-content">
        <h2>{{msg}}</h2>
    </div>
</template>

<script>
    export default {
        name: 'error_404',
        data () {
            return {
                msg: '404'
            }
        }
    }
</script>
